import axios from 'axios'


class APIConfInvioMail {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;

  }

  async setConfInvioMail(impostazioni_invio_mail, user) {


    let formData = new FormData();

    formData.append("username", user);

    for (var key in impostazioni_invio_mail) {
      formData.append(key, impostazioni_invio_mail[key]);
    }

    return axios.post(this.getUrlDomain("InvoiceSetConfigInvioMailEmt"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getConfInvioMail(user) {


    let formData = new FormData();

    formData.append("username", user);


    return axios.post(this.getUrlDomain("InvoiceGetConfigInvioMailEmt"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getConfInvioMailScadenze(user) {


    let formData = new FormData();

    formData.append("username", user);


    return axios.post(this.getUrlDomain("ScadenzeGetConfigInvioMail"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  async setConfInvioMailScadenze(impostazioni_invio_mail, user) {


    let formData = new FormData();

    formData.append("username", user);

    for (var key in impostazioni_invio_mail) {
      formData.append(key, impostazioni_invio_mail[key]);
    }

    return axios.post(this.getUrlDomain("ScadenzeSetConfigInvioMail"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getConfLogin(user) {


    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("getConfLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async goGetConfLogin(user) {


    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("goGetConfLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async setConfLogin(configuration, user) {


    let formData = new FormData();

    formData.append("username", user);

    for (var key in configuration) {
      formData.append(key, configuration[key]);
    }

    return axios.post(this.getUrlDomain("setConfLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async goSetConfLogin(configuration, user) {


    let formData = new FormData();

    formData.append("username", user);

    for (var key in configuration) {
      formData.append(key, configuration[key]);
    }

    return axios.post(this.getUrlDomain("goSetConfLogin"), formData, { 'Content-Type': 'multipart/form-data' });

  }



}

export default new APIConfInvioMail({
  url: "http://emtool.local/public/api/alertduedate/"
})
